import CCTM_parse from '../../CCTM_parse';
import React from "react";
import CCTM_transform from '../../CCTM_transform';

/**
 * @name CCTM
 * @function
 * @extends React.Component
 * @exported true
 * @description Main container for creating a custom menu by transforming and parsing XML structures.
 * @param {Object} props - Component properties.
 * @param {React.Component} props.self - Optional self-rendering component.
 * @param {React.Component} props.Component - Fallback component if self is not provided.
 * @param {string} props.xml - XML data to be parsed.
 * @param {string} [props.nav-id] - Optional navigation ID to filter specific parsed data.
 * @param {Object} [props.data] - Additional data to be passed to the component.
 * @example
 * export default function CCTM(props) {
 *  return (
 *    <CCTM xml={xmlData} Component={MyComponent} nav-id="menu1" data={{ key: 'value' }}>
 *      <div>Custom Content</div>
 *    </CCTM>
 *  );
 * }
 */

export default function CCTM(props) {
  
  // Initialize transformation process
  let transform = CCTM_transform.init(props.children);
  
  // Determine the component to use
  let Self = props.self ?? props.Component;
  
  // Parse children elements based on provided nav-id or parse the entire XML
  let children = {};
  if (props["nav-id"]) {
    children = CCTM_parse.init(props.xml).parseByID(transform.transform(), props["nav-id"]);
  } else {
    children = CCTM_parse.init(props.xml).parse(transform.transform());
  }
  
  // Retrieve additional data if available
  const data = props.data ?? {};
  
  // Render the component with transformed children and additional data
  return <Self {...data}>{children}</Self>;
}


